import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'get-user-documents', [
  'DELETE_ITEM',
  'UPDATE_LIST',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'documents',
  ],
});

const defaultReducer = createReqReducer(consts);

export default function(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case consts.DELETE_ITEM: {
      const { id } = payload;
      const updatedList = get(state, 'list').filter(item => item.id !== id);
      return {
        ...state,
        list: updatedList,
      };
    }
    case consts.UPDATE_LIST: {
      const { key } = payload;
      const existingList = get(state, 'list');
      const isExistingDocument = existingList.find(item => item.key === key);
      let updatedList;
      if (isExistingDocument) {
        updatedList = get(state, 'list').map(item => {
          if (key === item.key) {
            return payload;
          }
          return item;
        });
      } else {
        updatedList = [...existingList, payload];
      }

      return {
        ...state,
        list: updatedList,
      };
    }
    default:
      return defaultReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/redux/profiles/get-user-documents.js